const AMENITIES = {
  AC: {
    copyID: 'AMENITY_110_POWER_OUTLET',
    icon: 'amenityPowerCord',
  },
  BP: {
    copyID: 'AMENITY_PREMIUM_BREAKFAST',
    icon: 'amenityPremiumSilverware',
  },
  BC: {
    copyID: 'AMENITY_PREMIUM_BC_POWER',
    icon: 'amenityPowerCord',
  },
  BTL: {
    copyID: 'AMENITY_AUDIO_BTL',
    icon: 'amenityBluetoothAudio',
  },
  HBP: {
    copyID: 'AMENITY_PREMIUM_HOT_BREAKFAST',
    icon: 'amenityPremiumSilverware',
  },
  HCP: {
    copyID: 'AMENITY_PREMIUM_HOT_MEAL',
    icon: 'amenityPremiumSilverware',
  },
  OCP: {
    copyID: 'AMENITY_PREMIUM_MEAL',
    icon: 'amenityPremiumSandwich',
  },
  PL: {
    copyID: 'BKN_FLIGHT_DETAILS_PL',
    icon: 'amenityPremierLightSeatCut',
  },
  SNP: {
    copyID: 'AMENITY_PREMIUM_SNACK',
    icon: 'amenityPremiumApple',
  },
  SD: {
    copyID: 'AMENITY_SOFT_DRINKS',
    icon: 'amenitySoftDrink',
  },
  SDP: {
    copyID: 'AMENITY_PREMIUM_SOFT_DRINKS',
    icon: 'amenitySoftDrink',
  },
  ADP: {
    copyID: 'AMENITY_PREMIUM_ALCOHOLIC_BEVERAGES',
    icon: 'amenityPremiumAlcohol',
  },
  B: {
    copyID: 'AMENITY_BREAKFAST',
    icon: 'amenitySilverware',
  },
  HB: {
    copyID: 'AMENITY_HOT_BREAKFAST',
    icon: 'amenitySilverware',
  },
  HC: {
    copyID: 'AMENITY_HOT_MEAL',
    icon: 'amenitySilverware',
  },
  OC: {
    copyID: 'AMENITY_MEAL',
    icon: 'amenitySandwich',
  },
  SN: {
    copyID: 'AMENITY_SNACK',
    icon: 'amenityApple',
  },
  AD: {
    copyID: 'AMENITY_ALCOHOLIC_BEVERAGES',
    icon: 'amenityAlcohol',
  },
  SKP: {
    copyID: 'AMENITY_SKY_PRIORITY',
    icon: 'amenitySkyPriority',
  },
  USB: {
    copyID: 'AMENITY_USB_POWER_OUTLET',
    icon: 'amenityUSB',
  },
  AU: {
    copyID: 'AMENITY_AUDIO_SYSTEM',
    icon: 'amenityAudio',
  },
  PS15: {
    copyID: 'AMENITY_PERSONAL_ENTERTAINMENT_15',
    icon: 'amenityScreen',
  },
  PS13: {
    copyID: 'AMENITY_PERSONAL_ENTERTAINMENT_13',
    icon: 'amenityScreen',
  },
  PS16: {
    copyID: 'AMENITY_PERSONAL_ENTERTAINMENT_16',
    icon: 'amenityScreen',
  },
  PS18: {
    copyID: 'AMENITY_PERSONAL_ENTERTAINMENT_18',
    icon: 'amenityScreen',
  },
  OHV: {
    copyID: 'AMENITY_OVER_HEAD_VIDEO',
    icon: 'amenityProjector',
  },
  FB: {
    copyID: 'AMENITY_FLAT_BED',
    icon: 'amenityFlatBed',
  },
  XB: {
    copyID: 'AMENITY_EXTRA_BAG',
    icon: 'amenityExtraBag',
  },
  WS: {
    copyID: 'AMENITY_WIDE_SEAT',
    icon: 'farePremierCrow',
  },
  PS9: {
    copyID: 'AMENITY_PERSONAL_ENTERTAINMENT_9',
    icon: 'amenityScreen',
  },
  PS11: {
    copyID: 'AMENITY_PERSONAL_ENTERTAINMENT_11',
    icon: 'amenityScreen',
  },
  WF: {
    copyID: 'AMENITY_WIFI',
    icon: 'amenityWifi',
  },
  WFP: {
    copyID: 'AMENITY_WIFI',
    icon: 'amenityWifi',
  },
  ME: {
    copyID: 'AMENITY_MOBILE_ENTERTAINMENT',
    icon: 'amenityMobileEntertainment',
  },
  FM: {
    copyID: 'AMENITY_FREE_MESSAGING',
    icon: 'amenityFreeMessaging',
  },
};

export default AMENITIES;
